<template>
    <div id="petPage">
        <pet-and-project-breadcrumbs-component :object="object" :type="type"/>
        <div class="container">
            <story-line v-if="histories" :stories="histories" :is-show-add-history-btn="userData && userData.id === object.user_id" :is-show-progress="false"/>
        </div>
        <section class="single-product-desc">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8">
                        <div class="item-preview position-relative">

                            <div class="item__preview-slider slider-for">
                                <ul id="imageGallery">
                                    <li class="imageGallery__image" :key="idx"
                                        v-for="(photo, idx) in object.images" :data-thumb="`/storage/${photo.path.replace('original', 'preview')}`"
                                        :data-src="`/storage/${photo.path}`" :data-target="idx"
                                    >
                                        <img class="w-100" :src="`/storage` + photo.path | convertImage('full')"/>
                                    </li>
                                </ul>
                            </div>

                            <image-preview :images="object.images" @reset-preview-selected="previewImageIndex = null" :selected-image="previewImageIndex"/>

                            <div class="about">
                                <div class="about__header">
                                    <h4 class="d-flex">
                                        {{ object.name }}
                                        <span class="about__header-location" v-if="object.city">
                                            <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.99991 5.36366C9.99991 2.95363 7.98533 1 5.49995 1C3.01475 1 1 2.95363 1 5.36366C1 6.42328 1.38988 7.39484 2.03776 8.15056L5.25978 12.6585C5.37943 12.8259 5.62826 12.8259 5.74792 12.6585L9.02062 8.07982C9.14692 7.92654 9.26261 7.76499 9.36698 7.59516L9.40253 7.54571C9.78551 6.90346 9.99991 6.15885 9.99991 5.36366Z" stroke="#929292" stroke-width="0.8"/>
                                                <ellipse cx="5.55259" cy="5.3999" rx="1.92857" ry="2" stroke="#929292" stroke-width="0.8"/>
                                            </svg>
                                            {{ object.city.name }}
                                        </span>
                                    </h4>

                                    <template v-if="contentHeight > 66">
                                        <div class="about__header-description" :style="{'-webkit-line-clamp': !openContent ? 3 : 'unset'}">
                                            <p v-html="object.description"></p>

                                            <a v-if="!openContent" href="#" class="read-more" @click.prevent="openContent = true">{{$store.getters.t('pet_and_project_component_read_more')}}</a>
                                            <a v-else href="#" class="read-more--close" @click.prevent="openContent = false">{{$store.getters.t('pet_and_project_component_collapse')}}</a>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="about__header-description">
                                            <p v-html="object.description"></p>
                                        </div>
                                    </template>

                                </div>
                            </div>

                            <div class="item__preview-thumb" v-if="!!object.status && object.type !== 'PET_TYPE_MYSELF'">
                                <div class="item-action">
                                    <div class="action-btns">

                                        <template v-if="type === 'pet'">
                                            <button type="button" class="btn btn--round btn--lg"
                                                    :style="{background: ownerShiping ? '#77de51' : '#0674ec'}"
                                                    data-toggle="modal"
                                                    data-target="#ownerShipModal">
                                                {{$store.getters.t('pet_and_project_component_become_owner')}}
                                            </button>

                                            <!-- Modal -->
                                            <div class="modal fade" id="ownerShipModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                                <div class="modal-dialog modal-dialog-centered" role="document">
                                                    <div class="modal-content">
                                                        <div class="modal-header">
                                                            <h5 class="modal-title" id="exampleModalLongTitle">{{$store.getters.t('pet_and_project_component_become_owner_for')}} {{ object.name }}</h5>
                                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                                <span aria-hidden="true">&times;</span>
                                                            </button>
                                                        </div>
                                                        <div class="modal-body" v-if="!ownerShiping">

                                                            <form action="#">

                                                                <div class="mb-3">
                                                                    <input type="text" class="form-control" v-model="$v.ownerShipingForm.phone.$model" v-mask="'+1 (###) ###-####'" placeholder="+1 (999) 999-9999">
                                                                    <div class="text-danger" v-if="$v.ownerShipingForm.phone.$error">{{$store.getters.t('pet_and_project_component_field_invalid')}}</div>
                                                                </div>

                                                                <div>
                                                                    <textarea class="form-control" type="text" v-model="$v.ownerShipingForm.comment.$model" rows="3" :placeholder="$store.getters.t('pet_and_project_component_comment')"></textarea>
                                                                    <div class="text-danger" v-if="$v.ownerShipingForm.comment.$error">{{$store.getters.t('pet_and_project_component_leave_comment')}}</div>
                                                                </div>

                                                            </form>

                                                        </div>
                                                        <div class="modal-body" v-else>
                                                            {{$store.getters.t('pet_and_project_component_application_sent')}}
                                                        </div>
                                                        <div class="modal-footer" v-if="!ownerShiping">
                                                            <button type="button" class="btn btn-primary"
                                                                    :style="{background: ownerShiping ? '#77de51' : '#0674ec'}"
                                                                    @click.prevent="applyOwnership">{{$store.getters.t('pet_and_project_component_confirm')}}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </template>

                                        <template v-if="(object && userData) ? +object.user_id === +userData.id : false">

                                            <a :href="`/publication/pet/${object.id}`" class="btn btn--round btn--lg"
                                               v-if="type === 'pet' && object.type === 'PET_TYPE_VOLUNTEER'">{{$store.getters.t('pet_and_project_component_edit')}}</a>
                                            <a :href="`/publication/project/${object.id}`" class="btn btn--round btn--lg" v-if="type === 'project'">{{$store.getters.t('pet_and_project_component_edit')}}</a>

                                        </template>

                                        <template v-else>
                                            <a href="#" class="btn btn--round btn--lg btn--icon" @click.prevent="follow(true)" v-if="!followStatus">
                                                <span class="lnr lnr-heart"></span>
                                                {{$store.getters.t('pet_and_project_component_follow')}}
                                            </a>

                                            <a href="#" class="btn btn--round btn--lg btn--icon" :style="{background: followStatus ? '#77de51' : '#0674ec'}"
                                               @click.prevent="follow(false)" v-if="followStatus">
                                                <span class="lnr lnr-checkmark-circle"></span>
                                                {{$store.getters.t('pet_and_project_component_unfollow')}}
                                            </a>
                                        </template>

                                    </div>
                                </div>
                            </div>

                            <div class="item__preview-thumb" v-if="!!object.status === false && object.type !== 'PET_TYPE_MYSELF'">
                                <div class="item-action">
                                    <div class="action-btns">

                                        <template v-if="(object && userData) && +object.user_id === +userData.id">
                                            <a :href="`/publication/pet/${object.id}`" class="btn btn--round btn--lg"
                                               v-if="type === 'pet' && object.type === 'PET_TYPE_VOLUNTEER'">{{$store.getters.t('pet_and_project_component_edit')}}</a>
                                            <a :href="`/publication/project/${object.id}`" class="btn btn--round btn--lg" v-if="type === 'project'">{{$store.getters.t('pet_and_project_component_edit')}}</a>
                                        </template>

                                        <template v-if="followStatus">
                                            <a href="#" class="btn btn--round btn--lg btn--icon" :style="{background: followStatus ? '#77de51' : '#0674ec'}"
                                               @click.prevent="follow(false)">
                                                <span class="lnr lnr-checkmark-circle"></span>
                                                {{$store.getters.t('pet_and_project_component_unfollow')}}
                                            </a>
                                        </template>

                                    </div>
                                </div>
                            </div>

                            <div class="item__preview-thumb" v-if="object.type === 'PET_TYPE_MYSELF' && (object && userData) ? +object.user_id === +userData.id : false">
                                <div class="item-action">
                                    <div class="action-btns">

                                        <a :href="`/publication/personal_pet/${object.id}`" class="btn btn--round btn--lg" v-if="type === 'pet'">{{$store.getters.t('pet_and_project_component_edit')}}</a>

                                    </div>
                                </div>
                            </div>

                        </div>

                        <template v-if="media > 992">
                            <template v-if="isPet">
                                <pet-info :pet-info="petInfo"/>
                            </template>
                        </template>

                        <div v-else>

                            <div v-if="!!object.status">
                                <template v-if="object.is_moderated === 1">
                                    <div id="form-wrap">
                                        <div class="sidebar-card card-pricing" v-if="media < 992 && !!+object.need_sum && !!object.status && object.type !== 'PET_TYPE_MYSELF'">
                                            <div class="total-info-block d-flex">

                                                <!-- TODO Donations  -->
                                                <span class="item need-sum">{{ (+object.donationsTotal).toFixed() || 0 }} EUR</span>
                                                <span class="item sum">{{ (+object.need_sum).toFixed() }} EUR</span>
                                            </div>
                                            <div class="progress-form" v-if="progress < 100" :style="{background: progress < 30 ? '#FEF1F1': progress < 60 ? '#FEF9EC' : '#EAF1FC'}">
                                                <div class="progress-bar d-flex" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
                                                     :style="{width:  progress > 100 ? '100%' : (progress + '%'),
                                                      background: progress < 30 ? '#EE7372': progress < 60 ? '#F6C143' : '#2E76E4'}">
                                                    <span>{{ progress }} %</span>
                                                </div>
                                            </div>
                                            <div class="progress-form" v-else :style="{background: '#EAF1FC'}">
                                                <div class="progress-bar d-flex" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
                                                     :style="{width: '100%',
                                                              background: '#91DA66'}">
                                                    <span>{{ progress }} %</span>
                                                </div>
                                            </div>
                                            <div class="progress-form-labels d-flex" v-if="progress < 100">
                                                <span class="progress-form-labels__item progress-form-labels__item-donation">{{$store.getters.t('pet_and_project_component_collected')}}</span>
                                                <span class="progress-form-labels__item">{{$store.getters.t('pet_and_project_component_goal')}}</span>
                                            </div>
                                            <div class="progress-form-labels d-flex" v-else>
                                                <span class="progress-form-labels__item">
                                                    {{$store.getters.t('pet_and_project_component_goal_achieved')}}
                                                    <img src="/assets/images/icons/done.svg" alt="">
                                                </span>
                                            </div>

                                            <template v-if="progress < 100">

<!--                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="form__title">{{$store.getters.t('pet_and_project_component_payment_method')}}</div>
                                                    </div>

                                                    <div class="col-md-12">
                                                        <div class="payment-method">

                                                            <div class="custom-radio" :class="{'custom-radio&#45;&#45;active': payForm.paymentMethod === 'card'}">
                                                                <input type="radio" id="payment_card" name="paymentMethod" v-model="payForm.paymentMethod" value="card">
                                                                <label for="payment_card">
                                                                    <span class="circle"></span>
                                                                    {{$store.getters.t('pet_and_project_component_bank_card')}}
                                                                    <img src="/assets/images/icons/card.jpg" alt="">
                                                                </label>
                                                            </div>

                                                            <div class="custom-radio" :class="{'custom-radio&#45;&#45;active': payForm.paymentMethod === 'erip'}">
                                                                <input type="radio" id="payment_erip" name="paymentMethod" v-model="payForm.paymentMethod" value="erip">
                                                                <label for="payment_erip">
                                                                    <span class="circle"></span>
                                                                    {{$store.getters.t('pet_and_project_component_erip')}}
                                                                    <img src="/assets/images/icons/erip.jpg" alt="">
                                                                </label>
                                                            </div>

                                                        </div>
                                                    </div>


                                                </div>-->

                                                <div class="sum-items">
                                                    <div class="sum-items__row d-flex">
                                                        <div class="sum-item" :class="{active: payForm.activeSum === 5}" @click="payForm.activeSum = 5">
                                                            5 <span class="currency">EUR</span>
                                                        </div>
                                                        <div class="sum-item" :class="{active: payForm.activeSum === 10}" @click="payForm.activeSum = 10">
                                                            10 <span class="currency">EUR</span>
                                                        </div>
                                                        <div class="sum-item" :class="{active: payForm.activeSum === 20}" @click="payForm.activeSum = 20">
                                                            20 <span class="currency">EUR</span>
                                                        </div>
                                                    </div>
                                                    <div class="sum-items__row d-flex">
                                                        <div class="sum-item" :class="{active: payForm.activeSum === 50}" @click="payForm.activeSum = 50">
                                                            50 <span class="currency">EUR</span>
                                                        </div>
                                                        <div class="sum-item" :class="{active: payForm.activeSum === 100}" @click="payForm.activeSum = 100">
                                                            100 <span class="currency">EUR</span>
                                                        </div>
                                                        <div class="sum-item" :class="{active: payForm.activeSum === 500}" @click="payForm.activeSum = 500">
                                                            500 <span class="currency">EUR</span>
                                                        </div>
                                                    </div>
                                                    <div class="sum-items__row--input d-flex">
                                                        <div class="sum-item--input">
                                                            <input type="number" step="0.01" class="p-0" v-model="$v.payForm.activeSum.$model" :placeholder="$store.getters.t('pet_and_project_component_other_amount')">
                                                        </div>
                                                        <div class="sum-item--currency">
                                                            <span>EUR</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span class="text-danger text-danger--form" v-if="$v.payForm.activeSum.$error">{{$store.getters.t('pet_and_project_component_amount_invalid')}}</span>
                                                <div class="row" v-if="donators.length">
                                                    <div class="col-12">
                                                        <div class="form__title">{{$store.getters.t('pet_and_project_component_already_helped_and_subscribed')}}</div>
                                                        <div class="form__subscribers d-flex">
                                                            <div class="form__subscribers-item" v-for="({user = null, ...item}, idx) in donators" :key="idx">
                                                                <img :src="`/storage${user.avatar.path.replace('original', 'avatar')}`" alt="" v-if="user && user.avatar">
                                                                <span v-if="user && user.name">{{ getUserPM(user.name) }}</span>
                                                            </div>
                                                            <div class="form__subscribers-item" v-if="+donatorsTotal > 5">
                                                                <span> +{{ +donatorsTotal - 5 }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="form__title">{{$store.getters.t('common_email')}}</div>
                                                        <div class="text-danger text-danger--form" v-if="$v.payForm.$error && $v.payForm.email.$error">{{$store.getters.t('pet_and_project_component_fill_email')}}</div>
                                                        <input type="email" class="form-control form__input" :placeholder="$store.getters.t('pet_and_project_component_enter_email')" v-model="$v.payForm.email.$model">

                                                    </div>
                                                </div>
                                                <div class="row">
<!--                                                    <div class="col-12">
                                                        <div class="form__title tooltip-cusom">
                                                            Поддержать платформу!
                                                            <span>(выбранный процент будет прибавлен к сумме основного пожертвования)</span>
                                                        </div>
                                                        <div class="text-danger text-danger&#45;&#45;form" v-if="$v.payForm.tips.$error">Выберите, пожалуйста, значение</div>
                                                        <select class="form-control form__input" v-model="$v.payForm.tips.$model">
                                                            <option value="-1">Выберите значение</option>
                                                            <option value="0">Не поддерживать SaveUs</option>
                                                            <option value="5">5%</option>
                                                            <option value="10">10%</option>
                                                        </select>

                                                    </div>-->
                                                    <div class="col-12" >
                                                        <div class="form-group mb-0">
                                                            <div class="custom_checkbox custom_checkbox--selected mt-0" :class="{'custom_checkbox--selected-active': payForm.autoPay}">
                                                                <input type="checkbox" id="autoPay" class="" checked="" v-model="payForm.autoPay">
                                                                <label for="autoPay">
                                                                    <span class="shadow_checkbox"></span>
                                                                    <span class="text-muted">{{$store.getters.t('pet_and_project_component_regular_payment')}}</span>
                                                                </label>


                                                                <transition name="fade">
                                                                    <div class="tooltip-custom tooltip-custom--close" v-show="tooltipAutoPay">
                                                                        <button type="button" class="tooltip-close" @click.prevent="tooltipAutoPay = false">
                                                                            <span aria-hidden="true">&times;</span>
                                                                        </button>

                                                                        {{$store.getters.t('pet_and_project_component_autopay_desc')}}

                                                                    </div>
                                                                </transition>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="form-group mb-0">
                                                            <div class="text-danger text-danger--form" v-if="$v.payForm.agreement.$error">{{$store.getters.t('pet_and_project_component_accept_terms')}}</div>
                                                            <div class="custom_checkbox mt-0 custom_checkbox--selected">
                                                                <input type="checkbox" id="agreement" class="" v-model="$v.payForm.agreement.$model">
                                                                <label for="agreement">
                                                                    <span class="shadow_checkbox"></span>
                                                                    <span> {{$store.getters.t('pet_and_project_component_i_accept')}} <a target="_blank" href="/agreement">{{$store.getters.t('pet_and_project_component_user_agreement')}}</a></span>
                                                                    </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
<!--                                                <div class="cover-fee-info">-->
<!--                                                    <div>Покрытие расходов эквайринга</div>-->
<!--                                                    <div>+{{ coverFeeSum }} EUR</div>-->
<!--                                                </div>-->

                                                <div class="purchase-button mt-4">
                                                    <a href="#" class="btn btn--lg btn--round" @click.prevent="startPay">{{$store.getters.t('pet_and_project_component_support')}}</a>
                                                </div>
                                                <div class="card-pricing__footer d-flex">
                                                    <div class="card-pricing__footer-icon">
                                                        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M15 3.50125C15 3.61625 14.915 15.0013 7.5 15.0013C0.085 15.0013 0 3.61625 0 3.50125C0 3.30125 0.12 3.12125 0.305 3.04125L7.305 0.04125C7.43 -0.01375 7.57 -0.01375 7.695 0.04125L14.695 3.04125C14.88 3.12125 15 3.30125 15 3.50125Z" fill="#91DA66"/>
                                                            <path d="M4.78787 6.71335L3.71213 7.78909C3.59497 7.90625 3.59497 8.0962 3.71213 8.21335L6.28787 10.7891C6.40503 10.9062 6.59497 10.9062 6.71213 10.7891L11.2879 6.21335C11.405 6.0962 11.405 5.90625 11.2879 5.78909L10.2121 4.71335C10.095 4.5962 9.90503 4.5962 9.78787 4.71335L6.5 8.00122L5.21213 6.71335C5.09497 6.5962 4.90503 6.5962 4.78787 6.71335Z" fill="white"/>
                                                        </svg>
                                                    </div>
                                                    <div class="card-pricing__footer-content">{{$store.getters.t('pet_and_project_component_secure_collection')}}</div>
                                                </div>
                                            </template>
                                        </div>

                                        <a href="#" id="button-to-form" @click.prevent="scrollToForm">
                                            <span class="lnr lnr-heart"></span>
                                        </a>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="sidebar-card card-pricing card-pricing--placeholder d-flex"
                                         v-if="object.is_moderated === 0 || object.is_moderated === 2">
                                        {{ type === 'pet' ? $store.getters.t('pet_and_project_component_animal') : $store.getters.t('pet_and_project_component_project') }} {{$store.getters.t('pet_and_project_component_under_moderation')}}
                                        {{ type === 'pet' ? $store.getters.t('pet_and_project_component_will_be_published_f') : $store.getters.t('pet_and_project_component_will_be_published_m') }}, {{$store.getters.t('pet_and_project_component_after_check')}} {{ +object.need_sum }} EUR
                                    </div>
                                    <div class="sidebar-card card-pricing card-pricing--placeholder card-pricing--placeholder-rejected d-flex"
                                         v-if="object.is_moderated === 3">
                                        {{ type === 'pet' ? $store.getters.t('pet_and_project_component_animal_failed') : $store.getters.t('pet_and_project_component_project_failed') }} {{$store.getters.t('pet_and_project_component_moderation')}}
                                        <template v-if="object.reject_comment">{{$store.getters.t('pet_and_project_component_reason')}} " {{ object.reject_comment }}"</template>
                                        {{$store.getters.t('pet_and_project_component_fix_errors')}}
                                    </div>
                                </template>
                            </div>
                            <div v-else class="sidebar-card card-pricing card-pricing--placeholder d-flex">
                                {{ type === 'pet' ? $store.getters.t('pet_and_project_component_animal') : $store.getters.t('pet_and_project_component_project') }} {{$store.getters.t('pet_and_project_component_in_archive')}}
                            </div>

                            <template v-if="isPet">
                                <pet-info :pet-info="petInfo"/>
                            </template>
                        </div>

                        <div class="item-info tabs-custom">
                            <div class="item-navigation ">
                                <ul class="nav nav-tabs">
                                    <li class="w-25 text-center mr-0">
                                        <a href="#pet-events" class="active" aria-controls="product-details" role="tab" data-toggle="tab">{{$store.getters.t('pet_and_project_component_feed')}}
                                            <template v-if="object.newsEvents.length">({{ object.newsEvents.length }}
                                                <template v-if="object.newsEvents.length >= 50">+</template>
                                                )
                                            </template>
                                        </a>
                                    </li>
                                    <li class="w-25 text-center mr-0">
                                        <a href="#finance-report" aria-controls="product-comment" role="tab" data-toggle="tab">{{$store.getters.t('pet_and_project_component_fin_report')}}
                                            <template v-if="object.transactions.length">({{ object.transactions.length }})</template>
                                        </a>
                                    </li>
                                    <li class="w-25 text-center mr-0">
                                        <a href="#product-review" aria-controls="product-review" role="tab" data-toggle="tab">{{$store.getters.t('pet_and_project_component_comments')}}
                                            <template v-if="object.comments_count">({{ object.comments_count }})</template>
                                        </a>
                                    </li>
                                    <li class="w-25 text-center mr-0">
                                        <a href="#history" aria-controls="history" role="tab" data-toggle="tab">{{$store.getters.t('pet_and_project_component_history')}}
                                            <template v-if="histories.length">({{ histories.length }}
                                                <template v-if="histories.length >= 50">+</template>
                                                )
                                            </template>
                                        </a>
                                    </li>

                                </ul>
                            </div>

                            <div class="tab-content mt-0">
                                <div class="fade show tab-pane product-tab active" id="pet-events">
                                    <pet-and-and-project-events-tab-component :type="type" :object="object" :newsEvents="newsEvents"></pet-and-and-project-events-tab-component>
                                </div>

                                <div class="fade tab-pane product-tab" id="finance-report">
                                    <pet-and-and-project-transactions-tab-component :type="type" :object="object"></pet-and-and-project-transactions-tab-component>
                                </div>

                                <div class="fade tab-pane product-tab" id="product-review">
                                    <pet-and-and-project-thanks-tab-component :type="type" :object="object"></pet-and-and-project-thanks-tab-component>
                                </div>

                                <div class="fade tab-pane product-tab" id="history">
                                    <pet-and-and-project-history-tab-component :object="object"></pet-and-and-project-history-tab-component>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <special-title v-if="object.zb"></special-title>
                        <aside class="sidebar sidebar--single-product">
                            <div v-if="media > 992">
                                <div v-if="!!object.status">
                                    <template v-if="object.is_moderated === 1">

                                        <div class="sidebar-card card-pricing"
                                             v-if="media > 992 && !!+object.need_sum && !!object.status && object.type !== 'PET_TYPE_MYSELF'">
                                            <div class="total-info-block d-flex">

                                                <!-- TODO Donations  -->
                                                <span class="item need-sum">{{ (+object.donationsTotal).toFixed() || 0 }} EUR</span>
                                                <span class="item sum">{{ (+object.need_sum).toFixed() || 0 }} EUR</span>
                                            </div>
                                            <div class="progress-form" v-if="progress < 100" :style="{background: progress < 30 ? '#FEF1F1': progress < 60 ? '#FEF9EC' : '#EAF1FC'}">
                                                <div class="progress-bar d-flex" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
                                                     :style="{width:  progress > 100 ? '100%' : (progress + '%'),
                                                      background: progress < 30 ? '#EE7372': progress < 60 ? '#F6C143' : '#2E76E4'}">
                                                    <span>{{ progress }} %</span>
                                                </div>
                                            </div>
                                            <div class="progress-form" v-else :style="{background: '#EAF1FC'}">
                                                <div class="progress-bar d-flex" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
                                                     :style="{width: '100%',
                                                              background: '#91DA66'}">
                                                    <span>{{ progress }} %</span>
                                                </div>
                                            </div>
                                            <div class="progress-form-labels d-flex" v-if="progress < 100">
                                                <span class="progress-form-labels__item progress-form-labels__item-donation">{{$store.getters.t('pet_and_project_component_collected')}}</span>
                                                <span class="progress-form-labels__item">{{$store.getters.t('pet_and_project_component_goal')}}</span>
                                            </div>
                                            <div class="progress-form-labels d-flex" v-else>
                                                <span class="progress-form-labels__item">
                                                    {{$store.getters.t('pet_and_project_component_goal_achieved')}}
                                                    <img src="/assets/images/icons/done.svg" alt="">
                                                </span>
                                            </div>
                                            <template v-if="progress < 100">
                                                <div class="sum-items">
                                                    <div class="sum-items__row d-flex">
                                                        <div class="sum-item" :class="{active: payForm.activeSum === 5}" @click="payForm.activeSum = 5">
                                                            5 <span class="currency">EUR</span>
                                                        </div>
                                                        <div class="sum-item" :class="{active: payForm.activeSum === 10}" @click="payForm.activeSum = 10">
                                                            10 <span class="currency">EUR</span>
                                                        </div>
                                                        <div class="sum-item" :class="{active: payForm.activeSum === 20}" @click="payForm.activeSum = 20">
                                                            20 <span class="currency">EUR</span>
                                                        </div>
                                                    </div>
                                                    <div class="sum-items__row d-flex">
                                                        <div class="sum-item" :class="{active: payForm.activeSum === 50}" @click="payForm.activeSum = 50">
                                                            50 <span class="currency">EUR</span>
                                                        </div>
                                                        <div class="sum-item" :class="{active: payForm.activeSum === 100}" @click="payForm.activeSum = 100">
                                                            100 <span class="currency">EUR</span>
                                                        </div>
                                                        <div class="sum-item" :class="{active: payForm.activeSum === 500}" @click="payForm.activeSum = 500">
                                                            500 <span class="currency">EUR</span>
                                                        </div>
                                                    </div>
                                                    <div class="sum-items__row--input d-flex">
                                                        <div class="sum-item--input">
                                                            <input type="number" step="0.01" class="p-0" v-model="$v.payForm.activeSum.$model" :placeholder="$store.getters.t('pet_and_project_component_other_amount')">
                                                        </div>
                                                        <div class="sum-item--currency">
                                                            <span>EUR</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span class="text-danger text-danger--form" v-if="$v.payForm.activeSum.$error">{{$store.getters.t('pet_and_project_component_amount_invalid')}}</span>
                                                <div class="row" v-if="donators.length">
                                                    <div class="col-12">
                                                        <div class="form__title">{{$store.getters.t('pet_and_project_component_already_helped_and_subscribed')}}</div>
                                                        <div class="form__subscribers d-flex">
                                                            <div class="form__subscribers-item" v-for="({user = null, ...item}, idx) in donators" :key="idx">
                                                                <img :src="`/storage${user.avatar.path.replace('original', 'avatar')}`" alt="" v-if="user && user.avatar">
                                                                <span v-if="user && user.name">{{ getUserPM(user.name) }}</span>
                                                            </div>
                                                            <div class="form__subscribers-item" v-if="+donatorsTotal > 5">
                                                                <span> +{{ +donatorsTotal - 5 }}</span>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="form__title">{{$store.getters.t('common_email')}}</div>
                                                        <div class="text-danger text-danger--form" v-if="$v.payForm.$error && $v.payForm.email.$error">{{$store.getters.t('pet_and_project_component_fill_email')}}</div>
                                                        <input type="email" class="form-control form__input" :placeholder="$store.getters.t('pet_and_project_component_enter_email')" v-model="$v.payForm.email.$model">
                                                    </div>
                                                </div>
                                                <div class="row mt-2">
<!--                                                    <div class="col-12">
                                                        <div class="form__title tooltip-cusom">
                                                            Поддержать платформу!
                                                            <span>(выбранный процент будет прибавлен к сумме основного пожертвования)</span>
                                                        </div>
                                                        <div class="text-danger text-danger&#45;&#45;form" v-if="$v.payForm.tips.$error">Выберите, пожалуйста, значение</div>
                                                        <select class="form-control form__input" v-model="$v.payForm.tips.$model">
                                                            <option value="-1">Выберите значение</option>
                                                            <option value="0">Не поддерживать SaveUs</option>
                                                            <option value="5">5%</option>
                                                            <option value="10">10%</option>
                                                        </select>

                                                    </div>-->
<!--                                                    <div class="col-12" v-if="type === 'project' && object.allow_autopay && userData && payForm.paymentMethod !== 'erip'">-->
                                                    <div class="col-12">
                                                        <div class="form-group mb-0">
                                                            <div class="custom_checkbox custom_checkbox--selected mt-0" :class="{'custom_checkbox--selected-active': payForm.autoPay}">
                                                                <input type="checkbox" id="autoPay" class="" checked="" v-model="payForm.autoPay">
                                                                <label for="autoPay">
                                                                    <span class="shadow_checkbox"></span>
                                                                    <span class="text-muted">{{$store.getters.t('pet_and_project_component_regular_payment')}}</span>
                                                                </label>

                                                                <transition name="fade">
                                                                    <div class="tooltip-custom tooltip-custom--close" v-show="tooltipAutoPay">
                                                                        <button type="button" class="tooltip-close" @click.prevent="tooltipAutoPay = false">
                                                                            <span aria-hidden="true">&times;</span>
                                                                        </button>
                                                                        {{$store.getters.t('pet_and_project_component_autopay_desc')}}
                                                                    </div>
                                                                </transition>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="form-group mb-0">
                                                            <div class="text-danger text-danger--form" v-if="$v.payForm.agreement.$error">{{$store.getters.t('pet_and_project_component_accept_terms')}}</div>
                                                            <div class="custom_checkbox mt-0 custom_checkbox--selected">
                                                                <input type="checkbox" id="agreement" class="" v-model="$v.payForm.agreement.$model">
                                                                <label for="agreement">
                                                                    <span class="shadow_checkbox"></span>
                                                                    <span> {{$store.getters.t('pet_and_project_component_i_accept')}} <a target="_blank" href="/agreement">{{$store.getters.t('pet_and_project_component_user_agreement')}}</a></span>
                                                                </label>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
<!--                                                <div class="cover-fee-info">-->
<!--                                                    <div>Покрытие расходов эквайринга</div>-->
<!--                                                    <div>+{{ coverFeeSum }} EUR</div>-->
<!--                                                </div>-->

                                                <div class="purchase-button mt-4">
                                                    <a href="#" class="btn btn--lg btn--round" @click.prevent="startPay">{{$store.getters.t('pet_and_project_component_support')}}</a>
                                                </div>
                                                <div class="card-pricing__footer d-flex">
                                                    <div class="card-pricing__footer-icon">
                                                        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M15 3.50125C15 3.61625 14.915 15.0013 7.5 15.0013C0.085 15.0013 0 3.61625 0 3.50125C0 3.30125 0.12 3.12125 0.305 3.04125L7.305 0.04125C7.43 -0.01375 7.57 -0.01375 7.695 0.04125L14.695 3.04125C14.88 3.12125 15 3.30125 15 3.50125Z" fill="#91DA66"/>
                                                            <path d="M4.78787 6.71335L3.71213 7.78909C3.59497 7.90625 3.59497 8.0962 3.71213 8.21335L6.28787 10.7891C6.40503 10.9062 6.59497 10.9062 6.71213 10.7891L11.2879 6.21335C11.405 6.0962 11.405 5.90625 11.2879 5.78909L10.2121 4.71335C10.095 4.5962 9.90503 4.5962 9.78787 4.71335L6.5 8.00122L5.21213 6.71335C5.09497 6.5962 4.90503 6.5962 4.78787 6.71335Z" fill="white"/>
                                                        </svg>
                                                    </div>
                                                    <div class="card-pricing__footer-content">{{$store.getters.t('pet_and_project_component_secure_collection')}}</div>
                                                </div>
                                            </template>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="sidebar-card card-pricing card-pricing--placeholder d-flex"
                                             v-if="object.is_moderated === 0 || object.is_moderated === 2">
                                            {{ type === 'pet' ? $store.getters.t('pet_and_project_component_animal') : $store.getters.t('pet_and_project_component_project') }} {{$store.getters.t('pet_and_project_component_under_moderation')}}
                                            {{ type === 'pet' ? $store.getters.t('pet_and_project_component_will_be_published_f') : $store.getters.t('pet_and_project_component_will_be_published_m') }}, {{$store.getters.t('pet_and_project_component_after_check')}} {{ +object.need_sum }} EUR
                                        </div>
                                        <div class="sidebar-card card-pricing card-pricing--placeholder card-pricing--placeholder-rejected d-flex"
                                             v-if="object.is_moderated === 3">
                                            {{ type === 'pet' ? $store.getters.t('pet_and_project_component_animal_failed') : $store.getters.t('pet_and_project_component_project_failed') }} {{$store.getters.t('pet_and_project_component_moderation')}}
                                            <template v-if="object.reject_comment">{{$store.getters.t('pet_and_project_component_reason')}} " {{ object.reject_comment }}"</template>
                                            {{$store.getters.t('pet_and_project_component_fix_errors')}}
                                        </div>
                                    </template>
                                </div>
                                <div v-else class="sidebar-card card-pricing card-pricing--placeholder d-flex">
                                    {{ type === 'pet' ? $store.getters.t('pet_and_project_component_animal') : $store.getters.t('pet_and_project_component_project') }} {{$store.getters.t('pet_and_project_component_in_archive')}}
                                </div>
                            </div>


                            <div class="sidebar-card author-card sidebar-card--author" v-if="object.supervisor">
                                <div class="card-title">
                                    <h4>{{$store.getters.t('pet_and_project_component_curator')}}</h4>
                                </div>
                                <div class="author-infos">
                                    <a :href="`/volunteer/${object.supervisor.id}/profile`" class="author_avatar">
                                        <span class="info d-flex">
                                            {{ object.supervisor.name.split(' ')[0][0] }} {{ !object.supervisor.name.split(' ')[1] ? '' : object.supervisor.name.split(' ')[1][0] }}
                                        </span>
                                        <img :src="'/storage' + object.supervisor.avatar.path" :alt="object.supervisor.name" v-if="object.supervisor.avatar">
                                    </a>
                                    <div class="author pt-1">
                                        <h4>{{ object.supervisor.name }}</h4>
                                        <p>{{$store.getters.t('pet_and_project_component_on_site_since')}} <span class="created-at">{{ moment(object.supervisor.created_at).format('DD.MM.YYYY') }}</span></p>
                                    </div>
                                    <div class="author-btn">
                                        <a :href="'/volunteer/'+object.supervisor.id+'/profile'" class="btn btn--sm btn--round">{{$store.getters.t('pet_and_project_component_profile')}}</a>
                                        <!--                                        <a href="#" class="btn btn&#45;&#45;sm btn&#45;&#45;round">Написать</a>-->
                                    </div>
                                </div>
                            </div>

                            <div class="sidebar-card card--product-infos sidebar-card--infos">
                                <div class="card-title">
                                    <h4>{{$store.getters.t('pet_and_project_component_about_listing')}}</h4>
                                </div>

                                <div class="infos__content">
                                    <div class="infos__content-item infos__content-item--date d-flex">
                                        <span class="infos__content-title">{{$store.getters.t('pet_and_project_component_published')}}:</span>
                                        <span class="created-at">{{ moment(object.created_at).locale('en').format('DD MMMM YYYY') }}</span>
                                    </div>
                                    <div class="infos__content-item infos__content-item--filters" v-if="object.filters">
                                        <span class="infos__content-title">{{$store.getters.t('pet_and_project_component_special_needs')}}:</span>
                                        <div class="infos__content-list d-flex">
                                            <div class="infos__content-list-item" v-for="(filter, index) in object.filters" :key="index">
                                                <div class="infos__content-list-icon"
                                                     :style="{backgroundImage: 'url(/assets/images/' + (filter.icon ? filter.icon : 'sos.svg') + ')',
                                                               backgroundColor: '' + (filter.color ? filter.color : '#F1F2F4')  }"></div>
                                                <div class="infos__content-list-title" v-text="filter.name"></div>
                                            </div>
                                        </div>

                                        <a :href="`/publication/pet/${object.id}`" class="btn btn--round"
                                           v-if="type === 'pet' && (object && userData) ? +object.user_id === +userData.id : false ">{{$store.getters.t('pet_and_project_component_edit')}}</a>

                                    </div>
                                    <div class="infos__content-item infos__content-item--social">
                                        <span class="infos__content-title">{{$store.getters.t('pet_and_project_component_share')}}:</span>
                                        <div class="infos__content-list d-flex">
                                            <div class="infos__content-list-item">
                                                <a :href="`https://www.facebook.com/sharer/sharer.php?u=${location}`" target="_blank" class="infos__content-list-icon" style="border-color: #2E76E4">

                                                    <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M7.35196 5.60335L7.19274 7.72346H5.02235V15.0894H2.27374V7.72346H0.807262V5.60335H2.27374V4.94134V4.28771V4.17877C2.27374 3.55028 2.2905 2.58659 2.74302 1.98324C3.22067 1.34637 3.88268 0.918995 5.01397 0.918995C6.85754 0.918995 7.63687 1.17877 7.63687 1.17877L7.26816 3.34916C7.26816 3.34916 6.65642 3.17318 6.08659 3.17318C5.51676 3.17318 5.00559 3.3743 5.00559 3.94413V4.17877V4.94134V5.60335H7.35196Z" fill="#2E76E4"/>
                                                    </svg>

                                                </a>
                                            </div>
<!--                                            <div class="infos__content-list-item">
                                                <a :href="`https://vk.com/share.php?url=${location}`" target="_blank" class="infos__content-list-icon" style="border-color: #2687F5">

                                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M14.2736 3.60979C12.7455 5.72766 12.5847 5.54 13.8447 6.77319C15.0511 7.95276 15.2923 8.51574 15.3728 8.56936C15.8553 9.45404 14.8098 9.56128 14.8098 9.56128H12.7991C12.5311 9.56128 12.3702 9.61489 11.8072 9.18596C11.0566 8.64979 10.3596 7.22893 9.79659 7.41659C9.23362 7.60425 9.26042 8.89106 9.26042 8.89106C9.26042 8.89106 9.23362 9.21276 9.12638 9.32C8.96553 9.61489 7.81277 9.56128 7.81277 9.56128C7.81277 9.56128 5.82894 9.66851 4.14 7.68468C2.2366 5.59362 0.54766 1.4383 0.54766 1.4383C0.54766 1.4383 0.440426 1.17021 0.54766 1.03617C0.601277 0.928936 0.976596 0.955744 0.976596 0.955744H3.12128C3.12128 0.955744 3.46979 1.03617 3.65745 1.27745C3.95234 1.65277 4.00596 2.21574 4.4617 3.04681C5.34638 4.68213 5.77532 5.05745 6.07021 4.86979C6.52596 4.62851 6.39191 2.56425 6.39191 2.56425C6.39191 2.56425 6.41872 1.81362 6.17745 1.49191C5.98979 1.25064 5.66808 1.17021 5.50723 1.1434C5.37319 1.1166 5.56085 0.821702 5.82894 0.687659C6.17745 0.526808 6.68681 0.5 7.35702 0.5C7.62511 0.5 7.92 0.5 8.21489 0.526808C8.45617 0.553617 8.59021 0.553617 8.75106 0.607234C9.47489 0.821702 9.23362 1.54553 9.23362 3.28808C9.23362 3.85106 9.15319 4.62851 9.52851 4.89659C9.68936 5.00383 10.0915 4.8966 11.1102 3.10042C11.5928 2.26936 11.7 1.70638 11.9413 1.25064C12.0753 1.00936 12.4238 1.00936 12.4238 1.00936H14.6757C14.6757 1.00936 15.3996 0.955745 15.4532 1.17021C15.5604 1.51872 15.1851 2.32298 14.2736 3.60979Z"
                                                            fill="#2687F5"/>
                                                    </svg>

                                                </a>
                                            </div>-->
                                            <div class="infos__content-list-item">
                                                <a :href="`https://t.me/share/url?url=${location}`" target="_blank" rel="noreferrer" class="infos__content-list-icon" style="border-color: #29A9EB">

                                                    <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M15.008 1.2951L12.7444 11.9702C12.5737 12.7237 12.1283 12.9111 11.4954 12.5563L8.04643 10.0147L6.42457 8.80468C6.17206 8.61629 6.15459 8.24416 6.38833 8.03294L12.3292 2.66464C12.6072 2.41687 12.269 2.27956 11.8973 2.52735L4.38559 7.25718C4.13764 7.41331 3.83369 7.45283 3.55406 7.36531L0.592689 6.43845C-0.147335 6.20738 -0.160704 5.69839 0.7467 5.34348L14.0537 0.216891C14.6698 -0.0141423 15.2089 0.354141 15.008 1.2951Z" fill="#29A9EB"/>
                                                    </svg>

                                                </a>
                                            </div>
                                            <div class="infos__content-list-item">
                                                <a :href="`viber://forward?text=${location}`" class="infos__content-list-icon" style="border-color: #6C4DBB">

                                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M13.5495 11.9083C13.1169 12.4312 12.699 12.9817 12.1865 13.4193C11.7466 13.7948 11.1713 13.8401 10.5988 13.608C5.89521 11.7024 2.52171 8.46254 0.57607 3.78666C0.527156 3.66946 0.487621 3.54824 0.446057 3.42827C0.0818674 2.37876 0.191606 1.97108 1.05938 1.26512C1.34297 1.03425 1.64659 0.825252 1.95452 0.626819C2.47203 0.293331 3.04126 0.297355 3.43256 0.765144C4.08288 1.54303 4.7033 2.35688 5.23704 3.21626C5.63544 3.85783 5.49301 4.221 4.90833 4.70413C4.77325 4.81579 4.62828 4.91589 4.49294 5.02731C4.15461 5.30622 4.01167 5.6387 4.16094 6.07983C4.81506 8.01386 6.18008 9.23665 8.08288 9.88628C8.30414 9.96173 8.64983 9.79221 8.89186 9.6559C9.07256 9.55404 9.17849 9.32216 9.31839 9.14863C9.69627 8.67958 10.3076 8.48115 10.8122 8.79879C11.7141 9.36668 12.5784 9.99744 13.4261 10.6435C13.6078 10.7821 13.6519 11.0982 13.75 11.3118C13.6707 11.561 13.6598 11.775 13.5495 11.9083Z" fill="#6C4DBB"/>
                                                        <path d="M6.86461 0.539297C6.90136 0.383619 7.04404 0.313954 7.06914 0.301631C7.13422 0.269713 7.19232 0.264743 7.30792 0.254856L7.31091 0.2546C7.31091 0.2546 7.41204 0.248061 7.50074 0.250576C10.5161 0.330804 13.1205 2.45522 13.4955 5.67341C13.5206 5.88844 13.5635 6.14271 13.5759 6.66633C13.5784 6.7712 13.5802 6.96159 13.4504 7.08432C13.3919 7.13965 13.3247 7.1643 13.2778 7.17637C13.2127 7.16203 13.1101 7.12934 13.0312 7.04358C12.9268 6.92984 12.919 6.78261 12.9161 6.72784L12.9159 6.72442C12.8843 6.14019 12.8009 5.55646 12.6655 4.98681C12.1642 2.87497 10.2323 1.20829 8.05602 0.966846C7.80309 0.938678 7.5494 0.911013 7.2952 0.899444C7.12286 0.891648 6.95154 0.859959 6.88413 0.745275C6.83593 0.662266 6.85884 0.564036 6.86461 0.539297Z" fill="#6C4DBB"/>
                                                        <path d="M8.04892 2.5279C8.04335 2.5269 7.92195 2.52614 7.76837 2.48616C7.64748 2.45472 7.5532 2.42881 7.48148 2.34657C7.41356 2.26861 7.39506 2.17304 7.39227 2.10161C7.40773 2.04653 7.44042 1.96379 7.51569 1.90343C7.62188 1.81817 7.75595 1.8232 7.81906 1.82622C9.59641 1.91425 10.6489 2.93558 10.6489 2.93558C10.7402 3.02411 11.1221 3.40287 11.4544 4.01728C11.855 4.7582 11.9706 5.44806 12.0079 5.87058C12.017 5.96691 12.0145 6.10976 11.9475 6.25663C11.9199 6.31699 11.8888 6.38364 11.8155 6.43621C11.7266 6.50009 11.6302 6.50486 11.5889 6.50436C11.5431 6.48726 11.4858 6.45809 11.4354 6.40628C11.3702 6.33938 11.3403 6.26644 11.337 6.23626C11.2432 5.42669 11.1155 4.63597 10.6137 3.95214C9.97657 3.08447 9.07433 2.69993 8.04892 2.5279Z" fill="#6C4DBB"/>
                                                        <path d="M10.3732 5.60425C10.356 5.83889 10.2599 5.92541 10.2358 5.94578C10.1641 6.00589 10.0812 6.02249 10.0311 6.02802C9.97302 6.0167 9.89065 5.99105 9.82375 5.92541C9.72465 5.82808 9.71198 5.69428 9.70691 5.65052C9.68334 5.44756 9.5366 4.79819 9.20181 4.49865C8.99247 4.31129 8.7033 4.21245 8.28031 4.15158C8.11051 4.12719 7.94578 4.09299 7.88622 3.98132C7.84159 3.89744 7.87079 3.80285 7.88068 3.77083L7.88115 3.7693C7.95059 3.54698 8.22228 3.48285 8.24382 3.47832C8.42426 3.50347 9.57766 3.67977 10.1051 4.53085C10.3904 4.99134 10.3828 5.47321 10.3732 5.60425Z" fill="#6C4DBB"/>
                                                    </svg>

                                                </a>
                                            </div>
<!--                                            <div class="infos__content-list-item">
                                                <a :href="`https://connect.ok.ru/offer?url=${location}`" target="_blank"
                                                   class="infos__content-list-icon" style="border-color: #F6C143">

                                                    <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M5.99822 0.75C3.9415 0.75 2.24609 2.41761 2.24609 4.50213C2.24609 6.55886 3.91371 8.25426 5.99822 8.25426C8.08274 8.25426 9.75036 6.58665 9.75036 4.50213C9.75036 2.41761 8.05495 0.75 5.99822 0.75ZM5.99822 5.75284C5.30339 5.75284 4.74751 5.19697 4.74751 4.50213C4.74751 3.80729 5.30339 3.25142 5.99822 3.25142C6.69306 3.25142 7.24894 3.80729 7.24894 4.50213C7.24894 5.19697 6.69306 5.75284 5.99822 5.75284Z" fill="#F6C143"/>
                                                        <path d="M10.6126 10.7837C9.66763 11.3118 8.63927 11.6731 7.61091 11.8398L10.5292 15.4252C10.8628 15.8421 10.9461 16.4258 10.6404 16.8705C10.1679 17.5931 9.16735 17.6209 8.66706 16.9816L5.97109 13.6742L3.30291 16.9816C3.05276 17.2874 2.71924 17.4263 2.35792 17.4263C1.99661 17.4263 1.63529 17.2596 1.38515 16.9261C1.07942 16.5092 1.10721 15.8143 1.44074 15.3974L4.33127 11.7843C3.30291 11.5897 2.27454 11.2562 1.35736 10.7281C0.773691 10.3946 0.579136 9.67194 0.912659 9.06048C1.24618 8.47682 1.99661 8.28226 2.58027 8.61578C4.69258 9.81091 7.33297 9.81091 9.47308 8.64358C10.0567 8.31005 10.8072 8.5324 11.1129 9.11607C11.4186 9.72753 11.1963 10.4502 10.6126 10.7837Z" fill="#F6C143"/>
                                                    </svg>

                                                </a>
                                            </div>-->
                                            <div class="infos__content-list-item">
                                                <a id="copyBtn" href="#" target="_blank"
                                                   @click.stop.prevent="copyTestingCode"
                                                   class="infos__content-list-icon" style="border-color: #EE7372">

                                                    <svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M1.07944 4.52817L1.07004 4.53383L1.06132 4.54048C0.910476 4.65559 0.8 4.80974 0.8 5.00436C0.8 5.21316 0.902341 5.37841 1.08119 5.4816L4.46028 7.51738C4.538 7.56701 4.62572 7.59547 4.72035 7.59547C4.81407 7.59547 4.90228 7.56761 4.98251 7.52371C5.06846 7.47829 5.14285 7.41514 5.19499 7.33059C5.2477 7.24513 5.27043 7.14952 5.27043 7.05139C5.27043 6.85643 5.17673 6.69886 5.01823 6.59025L5.01844 6.58993L5.00789 6.58362L2.35485 4.99564L5.00789 3.40767L5.00792 3.40772L5.01209 3.40509C5.18192 3.29766 5.27043 3.13127 5.27043 2.93118C5.27043 2.83548 5.24947 2.73964 5.19507 2.65519C5.14123 2.57161 5.06417 2.51405 4.9767 2.47787C4.81392 2.40246 4.64283 2.40332 4.48025 2.48045L4.47127 2.48471L4.46276 2.48984L1.07944 4.52817ZM8.18313 8.7151L8.18312 8.71511L8.18454 8.71713C8.29195 8.86953 8.44887 8.95 8.63504 8.95C8.73044 8.95 8.82194 8.92799 8.90724 8.88528C9.01503 8.8313 9.08857 8.74151 9.1328 8.63519L9.13282 8.63519L9.13385 8.63262L11.8649 1.80336L11.865 1.80343L11.868 1.79507C11.926 1.62894 11.9158 1.46055 11.8267 1.30759C11.7821 1.22801 11.7199 1.16097 11.6382 1.11495C11.5564 1.06888 11.4661 1.05 11.3747 1.05C11.2683 1.05 11.1631 1.07284 11.0713 1.13162C10.9783 1.19109 10.9147 1.27731 10.8757 1.37669C10.8756 1.37698 10.8755 1.37727 10.8754 1.37757L8.14548 8.19528C8.14538 8.19551 8.14528 8.19575 8.14519 8.19599C8.07437 8.36985 8.07254 8.554 8.18313 8.7151ZM15.007 7.52274L15.007 7.52278L15.0106 7.52467C15.1823 7.61471 15.3699 7.62584 15.5397 7.51738L18.9188 5.48162C19.0976 5.37844 19.2 5.21318 19.2 5.00436C19.2 4.80973 19.0895 4.65558 18.9387 4.54048L18.93 4.53383L18.9206 4.52817L15.5372 2.48984L15.5287 2.48471L15.5198 2.48045C15.3547 2.40216 15.181 2.40362 15.0148 2.47785C14.9275 2.51515 14.8521 2.57451 14.8003 2.65911C14.749 2.74288 14.7296 2.83724 14.7296 2.93118C14.7296 3.13128 14.8181 3.29766 14.9879 3.40509L14.9879 3.40514L14.9923 3.4078L17.653 4.99564L14.9923 6.58348L14.9921 6.58315L14.9818 6.59025C14.8233 6.69886 14.7296 6.85643 14.7296 7.05139C14.7296 7.14779 14.7508 7.24204 14.8006 7.3269C14.8505 7.41185 14.9225 7.4762 15.007 7.52274Z"
                                                            fill="#EE7372" stroke="#EE7372" stroke-width="0.4"/>
                                                    </svg>

                                                </a>

                                                <transition name="fade">
                                                    <div class="tooltip-custom" v-show="tooltipCopy">{{$store.getters.t('pet_and_project_component_embed_code_copied')}}</div>
                                                </transition>

                                                <input type="hidden" id="testing-code" :value="frameSrc">
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </aside>
                    </div>
                </div>
            </div>
        </section>

        <section class="more_product_area section--padding">
            <random-pets-or-projects-component type="animals"></random-pets-or-projects-component>
        </section>

        <create-history :object="object" :type="type" @update-events="getEvents"/>
    </div>
</template>

<script>
import {mask} from 'vue-the-mask'
import {helpers, required, numeric, decimal, email, minValue} from 'vuelidate/lib/validators';

const phoneValidator = helpers.regex('phone', /^(?:\+1\s\(\d{3}\)\s[1-9]\d{2}-\d{2}-\d{2}|\+34\s[6789]\d{2}\s\d{3}\s\d{3})$/g);

import VueGallerySlideshow from 'vue-gallery-slideshow'

import StoryLine from './StoryLine'
import CreateHistory from './PetAndProjectCreateHistory'
import SpecialTitle from "./chunk/SpecialTitle.vue";

import imagePreview from './ImagePreview'
import PetInfo from './PetAndProject/PetInfo'
import {mapActions, mapGetters} from "vuex";


export default {
    directives: {mask},

    data() {
        return {
            media: 0,
            newsEvents: [],
            followStatus: false,
            moment: window.moment,
            contentHeight: 0,
            openContent: false,
            appRoutes: null,
            payForm: {
                paymentMethod: 'card', // erip
                activeSum: 20,
                email: null,
                tips: 0,
                autoPay: false,
                agreement: false
            },
            location: '',
            isShowAbout: false,
            tooltipCopy: false,
            tooltipAutoPay: false,
            previewImageIndex: null,
            donators: [],
            donatorsTotal: 0,

            ownerShiping: false,
            ownerShipingForm: {
                pet_id: this.object.id,
                comment: null,
                phone: null,
            }
        }
    },
    created() {
        this.appRoutes = window.appRoutes;
        this.myEventHandler();

        window.addEventListener("resize", this.myEventHandler);
    },

    destroyed() {
        window.removeEventListener("resize", this.myEventHandler);
        $('body').off('click', '#imageGallery .lslide.active')
    },
    mounted() {
        this.getHistories({targetId: this.object.id, type: this.type});
        this.getContent()
        this.getDonators()
        let self = this

        $('#imageGallery').lightSlider({
            gallery: true,
            item: 1,
            loop: true,
            thumbItem: 9,
            slideMargin: 0,
            enableDrag: false,
            currentPagerPosition: 'left',
            onSliderLoad: function (el) {
            }
        });

        this.location = window.location.href;
        this.followStatus = this.object.follow;

        this.newsEvents = this.object.newsEvents;


        $('body').on('click', '#imageGallery .lslide.active', function (e) {
            self.previewImageIndex = $(this).data('target')
        })

        if (this.userData.email) {
            this.payForm.email = this.userData.email;
        }
    },
    props: ['object', 'type'],

    watch: {
        'payForm.paymentMethod': function () {
            if (this.payForm.paymentMethod === 'erip') return this.payForm.autoPay = false
        },
        'payForm.autoPay': function () {
            if (!this.payForm.autoPay) return this.tooltipAutoPay = false
            return this.tooltipAutoPay = true
        },

        media() {
            this.getContent()
        }
    },
    computed: {
        ...mapGetters({histories: 'getterHistories'}),
        coverFeeSum() {
            const tipsSum = this.payForm.tips > -1 ? (this.payForm.activeSum * (this.payForm.tips / 100)) : 0;
            return Math.round(((+this.payForm.activeSum + +tipsSum) * 0.028 + 1) * 100) / 100 ;
        },

        userData() {
            return this.$store.getters.getUserData;
        },

        isPet() {
            let {type} = this
            return type === 'pet'
        },

        social() {

            const visible = parseFloat(this.object.to_children) > 0
                || parseFloat(this.object.to_dogs) > 0
                || parseFloat(this.object.to_cats) > 0
                || parseFloat(this.object.human_sociability) > 0
                || parseFloat(this.object.enrichment) > 0;

            return visible
        },

        frameSrc() {
            let str = `<iframe src="https://bypet.by/embed/${this.type}/${this.object.id}" width="100%" height="725">${this.$store.getters.t('pet_and_project_component_iframe_not_supported')}</iframe>`;
            return str
        },

        progress() {
            return +this.object.donationsProgress.toFixed()
        },

        petInfo() {
            if (!this.isPet) return null

            let {
                to_children, to_cats, to_dogs, human_sociability, enrichment, gender, petAgeCategory,
                is_vaccinated, is_parasite_treatment, is_sterilized, size, avatar, name, city, id,
                created_at, weight
            } = this.object

            return {
                to_children, to_cats, to_dogs, human_sociability, enrichment, gender, petAgeCategory,
                is_vaccinated, is_parasite_treatment, is_sterilized, size, avatar, name, city, id,
                created_at, weight
            }
        }

    },
    methods: {
        ...mapActions(['getHistories']),

        getContent() {
            let descr = document.querySelector(`.about__header .about__header-description > p`)
            if (!descr) return this.contentHeight = 0
            this.contentHeight = descr.scrollHeight
        },
        getUserPM(name) {
            if (!name) {
                return '';
            }
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },

        getDonators() {
            let url = this.type === 'pet' ? `/pets/${this.object.id}/donators` : `/projects/${this.object.id}/donators`

            axios
                .get(url, {params: {per_page: 5}})
                .then(response => {
                    response = response.data

                    if (response.success) {
                        this.donators = response.data
                        this.donatorsTotal = response.meta.total
                    }

                })
                .catch(err => {
                    err = err.response.data

                    if (!err.success) console.log(err)

                })
        },

        getEvents() {
            let url = `/pets/${this.object.id}/news-events`;

            if (this.type === 'project') url = `/projects/${this.object.id}/news-events`;

            axios.get(url)
                .then(response => {
                    response = response.data;
                    if (response.success) {
                        this.newsEvents = response.data
                    } else {
                        alert(this.$store.getters.t('common_error_reload'));
                    }
                })
                .catch()
        },

        scrollToForm() {
            if (this.media > 992) return;

            let formTop = document.getElementById('form-wrap').getBoundingClientRect().top;

            formTop += pageYOffset;

            window.scrollTo({
                top: (formTop - 100),
                behavior: "smooth"
            })

        },

        myEventHandler(e) {
            this.media = window.innerWidth
        },

        follow(followStatus) {
            let self = this;

            if (self.userData.id) {
                let request = {
                    follow: followStatus ? 1 : 0,
                };

                if (self.type === 'pet') {
                    request['pet_id'] = self.object.id
                } else if (self.type === 'project') {
                    request['project_id'] = self.object.id
                }

                axios.post('/api/follow', request)
                    .then(response => {
                        response = response.data;
                        if (response.success) {
                            self.followStatus = followStatus;
                        } else {
                            alert(this.$store.getters.t('common_error_reload'));
                        }
                    })
                    .catch((error) => {
                        alert(this.$store.getters.t('common_error_reload'));
                    })
                    .then();
            } else {
                location.href = '/auth/login';
            }
        },

        startPay() {
            this.$v.payForm.$touch();

            if (this.$v.payForm.$invalid) {
                return false;
            }

            let request = {
                paymentMethod: this.payForm.paymentMethod,
                email: this.payForm.email,
                amount: parseFloat(this.payForm.activeSum).toFixed(2),
                objectId: this.object.id,
                objectType: this.type,
                tips: this.payForm.tips,
                autoPay: this.payForm.autoPay,
            };

            axios.post('/startPay', request)
                .then(response => {
                    response = response.data;
                    if (response.success) {
                        if (this.payForm.paymentMethod === 'card') {
                            window.location.href = response.redirectUrl;
                        } else if (this.payForm.paymentMethod === 'erip') {
                            this.initBepaidWidget(response.token)
                        } else {
                            alert(this.$store.getters.t('common_error_reload'));
                        }
                    } else {
                        alert(this.$store.getters.t('common_error_reload'));
                    }
                })
                .catch((error) => {
                    alert(this.$store.getters.t('common_error_reload'));
                })
                .then();
        },

        initBepaidWidget(token) {
            let params = {
                checkout_url: "https://checkout.bepaid.by",
                token: token,

                closeWidget: function (status) {
                    // возможные значения status
                    // successful - операция успешна
                    // failed - операция не успешна
                    // pending - ожидаем результат/подтверждение операции
                    // redirected - пользователь отправлен на внешнюю платежную систему
                    // error - ошибка (в параметрах/сети и тд)
                    // null - виджет закрыли без запуска оплаты
                    console.debug('close widget callback')

                    if (status === 'successful') {
                        if (+this.payForm.tips === 0) {
                            window.dataLayer = window.dataLayer || [];
                            dataLayer.push({
                                event: 'support',
                                saveusincome: this.payForm.amount,
                                type: 'one_time'	//weekly, monthly, quarterly
                            });
                        } else {
                            window.dataLayer = window.dataLayer || [];
                            dataLayer.push({
                                event: 'support',
                                saveusincome: this.payForm.amount,
                                ecommerce: {
                                    // transaction_id: "T_12345",
                                    value: this.payForm.amount,
                                    currency: "EUR",
                                    items: [
                                        {
                                            item_id: this.object.id,   //ID можно взять из ссылки
                                            item_name: this.object.name,
                                            item_brand: this.type, //Dog, Kitten, Puppy
                                            // item_category: "girl", // boy
                                            item_category2: this.object.city.name,  //город, откуда живтоное.
                                        }
                                    ]
                                }
                            });
                        }
                    }

                }
            };

            new BeGateway(params).createWidget();
        },

        applyOwnership() {
            this.$v.$touch();
            if (this.$v.ownerShipingForm.$invalid) {
                return false;
            }

            let ownerModalClose = document.querySelector('#ownerShipModal .close'),
                params = {
                    comment: this.ownerShipingForm.comment,
                    pet_id: this.ownerShipingForm.pet_id,
                    details: {phone: this.ownerShipingForm.phone.replace(/([(]|[)])|(-)|(\s)/g, '')}
                };

            axios.post('/api/interactions/ownership/apply', params)
                .then(response => {
                    response = response.data;
                    if (response.success) {
                        this.ownerShiping = true;

                        window.dataLayer = window.dataLayer || [];
                        dataLayer.push({
                            'event': 'owner'
                        });

                        setTimeout(() => {
                            ownerModalClose.click()
                        }, 2000)

                    } else {
                        alert(this.$store.getters.t('common_error_reload'));
                    }
                })
                .catch((error) => {
                    alert(this.$store.getters.t('common_error_reload'));
                })
        },

        copyTestingCode() {
            let testingCodeToCopy = document.querySelector('#testing-code');
            testingCodeToCopy.setAttribute('type', 'text');
            testingCodeToCopy.select();

            try {
                var successful = document.execCommand('copy');
                this.tooltipCopy = true;

                setTimeout(() => {
                    this.tooltipCopy = false
                }, 5000)

            } catch (err) {
                alert('Oops, unable to copy');
            }

            /* unselect the range */
            testingCodeToCopy.setAttribute('type', 'hidden');
            window.getSelection().removeAllRanges()
        },

    },

    validations: {

        ownerShipingForm: {

            pet_id: {required},

            comment: {required},

            phone: {required, phoneValidator}

        },

        payForm: {
            email: {
                email,
                required
            },
            activeSum: {
                required,
                val: function (val) {

                    if (val && val !== '') {

                        if (typeof val === 'string') val = parseFloat(val)

                        return val > 0;

                    }

                    return false

                },
            },
            tips: {
                numeric,
                required,
                minValue: minValue(0)
            },

            agreement: {
                required,
                custom: function (value) {
                    return value;
                }
            }
        },
        historyForm: {
            comment: {
                required
            },

        },
    },
    components: {
        VueGallerySlideshow,
        imagePreview,
        StoryLine,
        CreateHistory,
        PetInfo,
        SpecialTitle
    },
}
</script>

<style lang="scss" scoped>

.author-card {
    .author-infos {

        .author_avatar {
            position: relative;

            .info {
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                right: 0;
                z-index: 1;
                font-size: 30px;
                line-height: 30px;
                text-align: center;
                align-items: center;
                justify-content: center;
            }

            img {
                position: relative;
                z-index: 2;
            }

        }

    }
}

.custom_checkbox--selected {

    padding: 10px 5px;
    border: 1px solid transparent;
    background: transparent;
    border-radius: 3px;
    transition: background .2s ease, border-color .2s ease, color .2s ease;

    &-active {
        border-color: #0674ec;
        background: rgba(0, 0, 0, .04);
        color: #0674ec;

        .text-muted {
            color: #0674ec !important;
        }

    }

}

.likes-block {
    position: absolute;
    right: 10px;
    font-size: 0.8rem;
    font-weight: normal;
    margin-top: 5px;
    color: green;
}

.product_title h4 {
    position: relative;
}

.author {
    margin-top: 35px;
}

.v-name {
    display: inline-block;
    margin-left: 5px;
}

.already-have-money {
    color: #a3a3a3;
    font-size: 0.8rem;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
    opacity: 0;
}

</style>

<style lang="scss">


.lSAction > a {
    background-position: center;
    border: 1px solid #929292;
    border-radius: 50%;
    font-family: Linearicons-Free;
    speak: none;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 30px;
    background-image: none !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #929292 !important;

    &::before {

        position: absolute;
        display: block;

        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        text-align: center;
    }
}

.lSAction > .lSPrev {
    &::before {
        content: '\e879';
    }
}

.lSAction > .lSNext {
    &::before {
        content: '\e87a';
    }
}

//.modal{
//    height: auto !important;
//}

.modal.fade {
    transition: opacity .15s linear !important;
}

.modal.fade .modal-dialog {
    transition: transform .3s ease-out !important;
}


.item-preview .item-action .modal a {
    color: #0674ec;
    transition: opacity .2s ease;

    &:hover {
        background: transparent;
        color: #0674ec;
        opacity: .8;
    }
}

.item-preview .item-action .modal a + a {
    margin: 0;
}

#petPage .card-pricing {
    padding: 30px 15px 15px;
}

#petPage .card-pricing .btn {
    line-height: 40px;
}

.card-pricing.card-pricing--placeholder {
    text-align: center;
    justify-content: center;
    min-height: 200px;
    align-items: center;
    color: #555;
}

.card-pricing.card-pricing--placeholder-rejected {
    background: rgba(255, 106, 109, 0.1);
    color: #ff6a6d;
}

.card-pricing .card-pricing__footer {
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
    padding-top: 15px;
    margin-top: 20px;
    border-top: 1px solid #ECECEC;
}

.card-pricing .card-pricing__footer-icon {
    margin-right: 5px;
}

.card-pricing .card-pricing__footer-content {
    font-size: 10px;
    line-height: 1;
    color: #555;
}

.sidebar-card.sidebar-card--author {
    padding: 20px 24px;
}

.sidebar-card--author .card-title {
    padding: 0 0 28px;
    margin-bottom: 0;
    font-weight: bold;
    font-size: 18px;
    line-height: 26px;
}

.sidebar-card--author .card-title h4 {
    margin-bottom: 0;
    font-size: inherit;
    line-height: inherit;
}

.sidebar-card--author .author-infos {
    padding: 20px 0 0;
}

.sidebar-card--author .author-infos .author {
    margin-top: 15px;
    font-size: 18px;
    line-height: 22px;
}

.sidebar-card--author .author-infos .author h4 {
    font-size: inherit;
    line-height: inherit;
}

.sidebar-card--author .author-infos .author p {
    font-weight: bold;
    font-size: 12px;
    line-height: 20px;
    color: #929292;
}

.sidebar-card--author .author-infos .author .created-at {
    color: #555;
}

.sidebar-card--author .author-infos .author-btn {
    margin-top: 30px;
}

.sidebar-card.sidebar-card--infos {
    padding: 20px 24px 30px;
}

.sidebar-card--infos .card-title {
    padding: 0 0 30px;
    margin-bottom: 0;
    font-weight: bold;
    font-size: 18px;
    line-height: 26px;
}

.sidebar-card--infos .card-title h4 {
    margin-bottom: 0;
    line-height: inherit;
    font-size: inherit;
}

.sidebar-card--infos .infos__content {
    padding: 20px 0 0;
    font-size: 12px;
    line-height: 20px;
    color: #333;
}

.sidebar-card--infos .infos__content .btn {
    display: block;
    padding: 8px 24px;
    width: intrinsic; /* Safari/WebKit используют нестандартное имя */
    width: -moz-max-content; /* Firefox/Gecko */
    width: -webkit-max-content; /* Chrome */
    margin: 0 auto;
    font-weight: bold;
    font-size: 12px;
    line-height: 20px;
}

.sidebar-card--infos .infos__content-item {
    margin-bottom: 25px;
}

.sidebar-card--infos .infos__content-item:last-child {
    margin-bottom: 0;
}

.sidebar-card--infos .infos__content-title {
    font-weight: bold;
    font-size: 12px;
    line-height: 20px;
    color: #333;
}

.sidebar-card--infos .infos__content-list {
    flex-flow: row wrap;
    padding-top: 15px;
}

.sidebar-card--infos .infos__content-list-item {
    width: 33.33%;
    padding: 0 5px;
    margin-bottom: 12px;
}

.sidebar-card--infos .infos__content-list-title {
    font-size: 10px;
    line-height: 12px;
    color: #555555;
    text-align: center;
}

.sidebar-card--infos .infos__content-list-icon {
    background: #F1F2F4 no-repeat center/20px;
    border-radius: 50%;
    margin: 0 auto 10px;
    width: 40px;
    height: 40px;
}


.sidebar-card--infos .infos__content-item--date {
    flex-wrap: nowrap;
}

.sidebar-card--infos .infos__content-item--date span {
    flex-grow: 1;
    width: 50px;

}


.sidebar-card--infos .infos__content-item--date .created-at {
    text-align: center;
    text-transform: uppercase;
    color: #555555;
    font-size: 10px;
    line-height: 20px;

}

.sidebar-card--infos .infos__content-item--social .infos__content-list {
    flex-wrap: nowrap;
}

.sidebar-card--infos .infos__content-item--social .infos__content-list-item {
    margin-bottom: 0;
    width: auto;
}

.sidebar-card--infos .infos__content-item--social .infos__content-list-icon {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    background: #fff;
    border: 1px solid #ececec;
    width: 30px;
    height: 30px;
    line-height: 30px;
    margin: 0;

}

.about {
    padding: 36px 23px 10px;
}

.about__header {
    margin-bottom: 25px;
}

.about__header h4 {
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    font-size: 24px;
    line-height: 24px;
    margin-bottom: 28px;
}

.about__header p {
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 0;
}

.about__header-location {
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    color: #929292;
}

.about__header-location svg {
    vertical-align: unset;
    margin-right: 2px;
}

.about__header-description {
    position: relative;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;


    a {
        color: #2e76e4;
    }

    .read-more {
        position: absolute;
        right: 0;
        bottom: 0;
        background: #fff;
        cursor: pointer;
        padding: 0 5px;

        &--close {
            display: block;
            margin-left: auto;
        }
    }
}

.about__body {
    padding-top: 36px;
    border-top: 1px solid #ECECEC;
}

.about__body-title {
    font-weight: bold;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 28px;
}

.about__body-item {
    margin-bottom: 28px;
}

.about__body-item-title {
    font-weight: bold;
    font-size: 14px;
    line-height: 26px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: #555555;
    margin-bottom: 14px;
}

.about__list {
    flex-flow: row wrap;
    justify-content: flex-start;
    padding: 0;
    margin: 0;
    list-style: none;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    color: #333333;
}

.about__list-item {
    position: relative;
    padding-right: 8px;
    padding-left: 11px;
    color: inherit;

    &::before {
        display: block;
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        background: currentColor;
        width: 3px;
        height: 3px;
        border-radius: 50%;
        transform: translateY(-50%);

    }

    &:first-child {
        padding-left: 0;

        &::before {
            display: none;
        }
    }
}

.about__rating {

}

.about__rating-item {
    width: 20%;
    padding-right: 17px;
    font-weight: 300;
    font-size: 10px;
    line-height: 16px;
    color: #555555;
    text-align: center;

    &:last-child {
        padding-right: 0;
    }
}

.about__rating-item img {
    display: block;
    margin: 0 auto 12px;

    width: 60px;
    height: auto;
}

.about__footer {
    position: relative;

    &::before {
        position: absolute;
        display: block;
        content: '';
        left: 0;
        top: 50%;

        transform: translateY(-50%);
        width: 100%;
        height: 1px;
        background: #ECECEC;
        z-index: 1;
    }
}

.about__footer .about__footer-btn {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    background: #EAF1FC;
    border: none;
    box-shadow: none;
    border-radius: 20px;
    margin: 0 auto;
    z-index: 2;
    font-size: 10px;
    font-weight: 700;
    color: #2e76e4;
}

.about__footer .about__footer-btn svg {
    margin-left: 10px;
}

.about__footer .about__footer-btn.about__footer-btn--active svg {
    transform: scaleY(-1);
}


.slide-enter-active, .slide-leave-active {
    transition: max-height .2s ease, opacity .2s ease;
}

.slide-enter, .slide-leave-to {
    max-height: 0;
    opacity: 0;
}

.slide-enter-to, .slide-leave {
    max-height: 1000px;
    opacity: 1;
}


.item-preview .item__preview-thumb {
    padding: 10px 23px;
}

.item-preview .item-action {
    border: none;
    padding: 0;
}

.item-preview .item-action .action-btns {
    margin-bottom: 20px;
}

.action-btns .btn {
    line-height: 45px;
    margin: 0 15px;
}

.modal .modal-header .close {
    position: absolute;
    right: 0;
    top: 0;
    padding: 10px;
    margin: 0;
}

.modal .modal-header {
    position: relative;
    padding: 15px 30px;
    border-top: 2px solid #0674ec;

}

.modal .modal-body {
    padding: 30px;
}

.modal .btn {
    padding: 10px 15px;
    line-height: 1;
    margin: 0 5px;
}

.tabs-custom {
    margin-bottom: 30px;
}

#button-to-form {
    position: fixed;
    right: 15px;
    bottom: 15px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 22px;
    border-radius: 50%;
    overflow: hidden;
    background: #0674ec;
    padding: 10px;
    box-shadow: 0 0 2px rgba(0, 0, 0, .3);
    color: #fff;
    transition: opacity .2s ease;
    z-index: 990;

    span {
        vertical-align: top;
    }

    &:hover {
        opacity: .8;
    }
}

.tabs-custom .nav-tabs a {
    font-size: 14px;
    line-height: 60px;
    font-weight: 700;
    padding: 0 10px !important;
}

.sum-items {
    margin-bottom: 10px;
    margin-top: 25px;
}

.sum-items__row--input,
.sum-items__row {
    margin: 0 -4px 8px;
    font-size: 18px;
    line-height: 26px;
}

.sum-item--input,
.sum-item--currency,
.sum-item {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: flex-end;
    padding: 12px;
    width: calc(33.33% - 8px);
    margin: 0 4px;
    font-weight: bold;
    font-size: inherit;
    line-height: inherit;
    color: #555555;
    background: #FFFFFF;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    border-radius: 2px;

    .currency {
        font-size: 8px;
        line-height: 20px;
        color: #2E76E4;
        margin-left: 5px;
    }
}

.sum-item--input {
    flex-grow: 1;
    width: auto;

    input {
        font-size: inherit;
        line-height: inherit;
        height: auto;
        border: none;

        &::focus {
            outline-offset: 0;
            outline: none;
        }
    }

}

.sum-item--currency {
    min-width: calc(33.33% - 8px);
    color: #2E76E4;
}

.form {
    &__title {
        font-weight: bold;
        font-size: 14px;
        line-height: 22px;
        margin: 20px 0 10px;
    }

    &__input {
        padding: 9px !important;
        font-size: 12px;
        line-height: 22px;
        color: #929292;
        border: 1px solid #CED4DA;
        border-radius: 3px;
        -webkit-appearance: none;
        -moz-appearance: none;
        height: auto;
        margin-bottom: 15px;
    }

    &__subscribers {
        &-item {
            position: relative;
            z-index: 1;
            width: 35px;
            height: 35px;
            border-radius: 50%;
            overflow: hidden;
            border: 1px solid #2e76e4;
            background: #2e76e4;
            color: #fff;
            font-size: 10px;
            text-align: center;
            line-height: 35px;

            img {
                position: relative;
                z-index: 1;
                width: 100%;
                height: 100%;
                border-radius: 50%;
                vertical-align: top;
            }

            span {
                position: absolute;
                left: 50%;
                top: 50%;
                text-transform: uppercase;
                transform: translate(-50%, -50%);
            }

            margin-left: -15px;

            &:first-child {
                margin-left: 0;
            }

            &:last-child {
                background: #EAF1FC;
                color: #2e76e4;
            }

        }
    }
}

.text-danger--form {
    font-size: 13px;
    line-height: 15px;
    padding: 0 10px;
    font-weight: 600;
}

.sum-item.active, .sum-item:hover {
    background-color: #007bff;
    color: #fff;

    .currency {
        color: inherit;
    }
}

.total-info-block {
    font-size: 18px;
    line-height: 22px;
    color: #929292;
    flex-wrap: nowrap;

    .item {
        position: relative;
        min-width: 50%;
        flex-grow: 1;
        text-align: center;

        & + .item {
            &::before {
                position: absolute;
                content: '';
                display: block;
                left: 0;
                top: 0;
                bottom: 0;
                width: 1px;
                background: #ececec;
            }
        }
    }
}

.sum-item:last-child {
    border-right: none;
}

.sum-item:hover {
    background-color: #007bff;
}

.item__preview-slider {
    .slick-prev {
        left: 25px;
        z-index: 1;
    }

    .slick-next {
        right: 25px;
        z-index: 1;
    }

    .slick-prev:before, .slick-next:before {
        color: #fff;
    }
}

.card-pricing .purchase-button {
    width: 100%;
    max-width: 210px;
    margin: 0 auto;
}

.card-pricing .cover-fee-info {
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #7e7e7e;
}

.thumb-slider {
    .slick-prev {

    }

    .slick-next {

    }
}

.slick-prev:before, .slick-next:before {
    color: #138ce5;
}

.pet-slide {

}

.item-thumb {

}

.lSSlideOuter .lSPager.lSGallery li {
    border: 2px solid transparent;
}

.lSSlideOuter .lSPager.lSGallery li.active, .lSSlideOuter .lSPager.lSGallery li:hover {
    border-color: #0056b3;
}

.lSSlideOuter img {
    height: 500px;
    width: auto !important;
    margin: 0 auto;
    display: block;
}


.total-info-block {
    padding: 10px 5px;
}

.need-sum {
    color: #333;
    font-weight: bold;
}

.progress-form {
    width: 100%;
    max-width: 250px;
    margin: 0 auto;
    display: block;
    height: auto;
    margin-bottom: 5px;
    background: #FEF9EC;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    border-radius: 50px;

    .progress-bar {
        height: 10px;
        justify-content: center;
        align-items: center;
        border-radius: 50px;
        flex-direction: row;

        span {
            font-size: 9px;
            line-height: 10px;
            color: #fff;
        }

    }

    &-labels {
        flex-wrap: nowrap;
        font-size: 10px;
        line-height: 20px;
        color: #929292;
        margin-bottom: 25px;

        &__item {
            flex-grow: 1;
            min-width: 50%;
            text-align: center;

            &-donation {
                color: #333;
            }
        }
    }
}

.tooltip-cusom {
    position: relative;

    span {
        display: block;
        top: 100%;
        left: 0;
        position: absolute;
        background: #0674ec;
        font-size: 10px;
        line-height: 12px;
        color: #fff;
        padding: 10px 15px;
        border-radius: 5px;
        z-index: -1;
        opacity: 0;
        visibility: hidden;
        transition: opacity .2s ease;

        &::before {
            display: block;
            content: '';
            position: absolute;
            left: 20px;
            top: -5px;
            width: 0;
            height: 0;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;

            border-bottom: 5px solid #0674ec;
        }
    }

    &:hover {
        span {
            opacity: 1;
            z-index: 1;
            visibility: visible;
        }
    }
}

.no-transactions {
    text-align: center;
    padding: 0 0 15px 0;
}

.modal .modal-title {
    margin-bottom: 0;
}

.modal .modal-header {
    padding: 10px 30px;
}

.modal .modal-body {
    padding: 10px 30px 30px 30px;
}

.rating_modal .modal-body .text_field {
    margin-bottom: 0;
    height: unset;
    //padding: 5px 25px;
}

.success-result {
    line-height: 50px;
    min-width: 170px;
}

ul.nav-tabs li a {
    line-height: 25px;
    font-size: 13px;
    display: inline-block;
    width: 100%;


    @media (min-width: 0) and (max-width: 768px) {
        line-height: 9px;
        font-size: 9px;
        padding: 0 5px;
    }

    span {
        display: block;
        width: 100%;
        text-align: center;
    }
}

ul.nav-tabs li a span {
    margin-top: 10px;

    @media (min-width: 0) and (max-width: 768px) {
        display: inline-block;
        margin: 5px 0;
    }
}

ul.nav-tabs li:last-child > a {
    @media (min-width: 0) and (max-width: 768px) {
        padding: 0;
    }

}

.paw-text {
    font-size: 13px;

    @media (min-width: 0) and (max-width: 768px) {
        font-size: 10px;
    }
}


@media screen and (max-width: 992px) {
    .progress-form {
        max-width: 450px;
    }
    .sidebar-card--infos .infos__content-list-item {
        width: 20%;
    }

    .card-pricing .purchase-button .btn {
        width: 100%;
    }


}


@media screen and (max-width: 767px) {
    .notifications_module .notification .notification__info {
        width: 100%;
    }

    .tabs-custom .nav-tabs {
        flex-direction: column;
    }

    .tabs-custom .nav-tabs .w-25 {
        width: 100% !important;
    }

    .action-btns .btn {
        font-size: 13px;
    }


    .lSSlideOuter img {
        height: 350px;
    }

}

@media screen and (max-width: 500px) {

    .sidebar-card--infos .infos__content-list-item {
        width: 33.33%;
    }

    .about {
        padding: 36px 10px 10px;
    }
    .about__body {
        text-align: center;
    }

    .about__list {
        justify-content: center;
    }
    .about__header {
        text-align: center;
    }
    .about__header .d-flex {
        flex-direction: column;
        align-items: center;
    }

    .about__header .about__header-location {
        margin-top: 20px;
    }

    .about__rating {
        flex-wrap: wrap;
    }

    .about__rating-item {
        padding: 0 10px;
        width: 50%;
        margin-bottom: 15px;
    }
    .item-preview .item-action .action-btns > a,
    .item-preview .item-action .action-btns > .btn {
        margin: 20px 0 0;
    }

    .item-preview .item-action .action-btns {
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
    }

    .progress-form {
        max-width: 300px;
    }

    .modal .modal-title {
        font-size: 16px;
    }

    .modal .modal-body {
        padding: 15px;
        font-size: 12px;
    }
    .modal .btn {
        margin-top: 0;
    }

    .sidebar-card.sidebar-card--infos {
        padding: 10px;
    }
    .sidebar-card.sidebar-card--author {
        padding: 10px;
    }

    .lSSlideOuter img {
        height: 200px;
    }


    .custom_checkbox {
        label span, .form-group p.label span {
            font-size: 13px;
            line-height: 16px;
        }
    }

    .about__header-description {
        .read-more--close {
            margin-left: unset;
            text-align: center;
        }
    }

}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
    opacity: 0;
}

.not-checked-btn {
    background: #eaf1fc;
    color: #0674ec;

}


</style>
